/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightDownIcon20Regular = forwardRef('ArrowDCornerRightDownIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.5 3.75c.966 0 1.75.784 1.75 1.75v10.528l-3.957-4.146a.75.75 0 1 0-1.086 1.036l4.166 4.363a2.25 2.25 0 0 0 3.255 0l4.165-4.363a.75.75 0 0 0-1.085-1.036l-3.958 4.146V5.5a3.25 3.25 0 0 0-3.25-3.25H2a.75.75 0 0 0 0 1.5h8.5Z" })));
});
